import { useState, useEffect } from "react";
import { supabase, getUserRole } from "./supabaseClient";
import { AuthContext, AUTH_DEFAULT } from "./AuthContext";
import CreazioneSistemi from "./pages/CreazioneSistemi";
import Dashboard from "./pages/Dashboard";
import MonitorLive from "./pages/MonitorLive";
import DiarioOperativo from "./pages/DiarioOperativo";
import PortfolioStrategie from "./pages/PortfolioStrategie";
import PortfolioSistemi from "./pages/PortfolioSistemi";
import EsportaDatabase from "./pages/EsportaDatabase";
import Statistiche from "./pages/Statistiche";
import SetupNuovaStagione from "./pages/SetupNuovaStagione";
import Impostazioni from "./pages/Impostazioni";
import InterventiDB from "./pages/InterventiDB";
import MailSistema from "./pages/MailSistema";
import NoteRilascio from "./pages/NoteRilascio";
import AnagraficaStorico from "./pages/AnagraficaStorico";
import GuidaDrawer from "./pages/Guida";

// ===== CONFIGURAZIONE MENU =====
const MENU_ITEMS = [
  { id: "dashboard",      label: "Dashboard",                icon: "📊", comp: Dashboard },
  { id: "monitor-live",   label: "Monitor Live",             icon: "📅", comp: MonitorLive },
  { id: "diario",         label: "Diario Operativo",         icon: "📓", comp: DiarioOperativo },
  { id: "interventi-db",  label: "Interventi su DB",         icon: "🏥", comp: InterventiDB },
  { id: "creazione",      label: "Creazione Sistemi",        icon: "⚙️", comp: CreazioneSistemi },
  { id: "portfolio",      label: "Portfolio Sistemi",         icon: "💼", comp: PortfolioSistemi },
  { id: "strategie",      label: "Portfolio Strategie",       icon: "📋", comp: PortfolioStrategie },
  { id: "dati",           label: "Esporta Database",        icon: "📥", comp: EsportaDatabase },
  { id: "statistiche",    label: "Statistiche",              icon: "🔍", comp: Statistiche },
  { id: "setup-stagione", label: "Setup nuova stagione",     icon: "🚀", comp: SetupNuovaStagione },
  { id: "impostazioni",   label: "Impostazioni",             icon: "🔧", comp: Impostazioni },
  { id: "mail-sistema",   label: "Mail di sistema",          icon: "📨", comp: MailSistema },
  { id: "anagrafica-storico", label: "Anagrafica del Database storico", icon: "📚", comp: AnagraficaStorico },
  { id: "note-rilascio",  label: "Note di rilascio",         icon: "📝", comp: NoteRilascio },
];

// ===== INJECT CSS SIDEBAR =====
if (typeof document !== "undefined" && !document.getElementById("sidebar-styles")) {
  const s = document.createElement("style");
  s.id = "sidebar-styles";
  s.textContent = `
    .sidebar {
      position: fixed; top: 0; left: 0; height: 100vh;
      background: #1B2846;
      display: flex; flex-direction: column;
      transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 900; overflow: visible;
      box-shadow: 2px 0 12px rgba(0,0,0,0.15);
    }
    .sidebar.open { width: 240px; }
    .sidebar.closed { width: 56px; }

    .sidebar-header {
      display: flex; align-items: center; gap: 12px;
      padding: 16px 14px; min-height: 56px;
      border-bottom: 1px solid rgba(255,255,255,0.08);
    }
    .sidebar-hamburger {
      background: none; border: none; color: #94A3B8;
      font-size: 20px; cursor: pointer; padding: 4px;
      border-radius: 6px; display: flex; align-items: center;
      justify-content: center; min-width: 28px; min-height: 28px;
      transition: background 0.15s, color 0.15s;
    }
    .sidebar-hamburger:hover { background: rgba(255,255,255,0.08); color: #E2E8F0; }
    .sidebar-logo {
      font-family: 'DM Sans', sans-serif; font-size: 16px;
      font-weight: 700; color: #E2E8F0; white-space: nowrap;
      letter-spacing: -0.02em; opacity: 1;
      transition: opacity 0.2s;
    }
    .sidebar.closed .sidebar-logo { opacity: 0; width: 0; }

    .sidebar-nav { flex: 1; padding: 8px 0; overflow-y: auto; overflow-x: visible; }
    .sidebar.closed .sidebar-nav { overflow: visible; }
    .sidebar-nav::-webkit-scrollbar { width: 4px; }
    .sidebar-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }

    .sidebar-item {
      display: flex; align-items: center; gap: 12px;
      padding: 10px 14px; margin: 2px 8px;
      border-radius: 8px; cursor: pointer;
      color: #94A3B8; font-family: 'DM Sans', sans-serif;
      font-size: 13px; font-weight: 500;
      white-space: nowrap; overflow: hidden;
      transition: background 0.15s, color 0.15s;
      border: none; background: none; width: calc(100% - 16px);
      text-align: left;
    }
    .sidebar-item:hover {
      background: rgba(255,255,255,0.06); color: #CBD5E1;
    }
    .sidebar-item.active {
      background: rgba(59, 130, 246, 0.15); color: #60A5FA;
      font-weight: 600;
    }
    .sidebar-item-icon {
      font-size: 18px; min-width: 24px; text-align: center;
      line-height: 1; display: flex; align-items: center; justify-content: center;
    }
    .sidebar.closed .sidebar-item-icon { font-size: 20px; min-width: 28px; }
    .sidebar-item-label {
      opacity: 1; transition: opacity 0.2s;
    }
    .sidebar.closed .sidebar-item-label { opacity: 0; width: 0; overflow: hidden; }
    .sidebar.closed .sidebar-item {
      justify-content: center; padding: 10px 0; margin: 2px 4px;
      position: relative; overflow: visible; width: calc(100% - 8px);
    }
    .sidebar.closed .sidebar-item.active {
      background: rgba(59, 130, 246, 0.25);
      border-radius: 8px;
      box-shadow: inset 3px 0 0 #60A5FA;
    }

    /* Tooltip custom per sidebar chiusa */
    .sidebar-item .sidebar-tooltip {
      display: none; position: absolute; left: 100%; top: 50%;
      transform: translateY(-50%); margin-left: 12px;
      background: #1E293B; color: #F1F5F9; font-size: 12px;
      font-weight: 600; padding: 6px 12px; border-radius: 6px;
      white-space: nowrap; pointer-events: none; z-index: 1000;
      box-shadow: 0 2px 8px rgba(0,0,0,0.25);
    }
    .sidebar.closed .sidebar-item:hover .sidebar-tooltip { display: block; }
    .sidebar.open .sidebar-tooltip { display: none !important; }

    .sidebar-footer {
      padding: 8px 0 12px 0;
      border-top: 1px solid rgba(255,255,255,0.08);
    }
    .sidebar-footer-version {
      padding: 4px 14px 0 14px;
      color: #475569; font-size: 10px; font-family: 'DM Sans', sans-serif;
      white-space: nowrap; overflow: hidden;
      transition: opacity 0.2s;
    }
    .sidebar.closed .sidebar-footer-version { opacity: 0; }

    .main-content {
      transition: margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      min-height: 100vh;
    }
    .main-content.sidebar-open { margin-left: 240px; }
    .main-content.sidebar-closed { margin-left: 56px; }
  `;
  document.head.appendChild(s);
}

// ===== SCHERMATA LOGIN SUPABASE AUTH =====
function BetaLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [errore, setErrore] = useState("");
  const [caricamento, setCaricamento] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore("");
    setCaricamento(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password: pwd });
    setCaricamento(false);
    if (error) {
      setErrore("Email o password non corretti");
      setPwd("");
    } else {
      onLogin();
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#1B2846",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        background: "#fff", borderRadius: 16, padding: "48px 40px",
        width: 360, boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
        textAlign: "center",
      }}>
        <div style={{
          fontSize: 28, fontWeight: 700, color: "#1B2846",
          marginBottom: 8, letterSpacing: "-0.02em",
        }}>
          Investisport
        </div>
        <div style={{ marginBottom: 32 }} />
        <div style={{ marginBottom: 12 }}>
          <input
            type="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setErrore(""); }}
            placeholder="Email"
            style={{
              width: "100%", padding: "12px 16px", fontSize: 14,
              border: errore ? "2px solid #EF4444" : "2px solid #E2E8F0",
              borderRadius: 8, outline: "none", boxSizing: "border-box",
              fontFamily: "'DM Sans', sans-serif", transition: "border-color 0.2s",
            }}
            onFocus={(e) => e.target.style.borderColor = errore ? "#EF4444" : "#3B82F6"}
            onBlur={(e) => e.target.style.borderColor = errore ? "#EF4444" : "#E2E8F0"}
            autoFocus
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <input
            type="password"
            value={pwd}
            onChange={(e) => { setPwd(e.target.value); setErrore(""); }}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
            placeholder="Password"
            style={{
              width: "100%", padding: "12px 16px", fontSize: 14,
              border: errore ? "2px solid #EF4444" : "2px solid #E2E8F0",
              borderRadius: 8, outline: "none", boxSizing: "border-box",
              fontFamily: "'DM Sans', sans-serif", transition: "border-color 0.2s",
            }}
            onFocus={(e) => e.target.style.borderColor = errore ? "#EF4444" : "#3B82F6"}
            onBlur={(e) => e.target.style.borderColor = errore ? "#EF4444" : "#E2E8F0"}
          />
        </div>
        {errore && (
          <div style={{ color: "#EF4444", fontSize: 12, marginBottom: 12 }}>
            {errore}
          </div>
        )}
        <button
          onClick={handleSubmit}
          disabled={caricamento}
          style={{
            width: "100%", padding: "12px 0", fontSize: 14,
            fontWeight: 600, color: "#fff",
            background: caricamento ? "#93C5FD" : "#3B82F6",
            border: "none", borderRadius: 8, cursor: caricamento ? "default" : "pointer",
            fontFamily: "'DM Sans', sans-serif", transition: "background 0.2s",
          }}
          onMouseEnter={(e) => { if (!caricamento) e.target.style.background = "#2563EB"; }}
          onMouseLeave={(e) => { if (!caricamento) e.target.style.background = "#3B82F6"; }}
        >
          {caricamento ? "Accesso in corso..." : "Accedi"}
        </button>
        <div style={{ fontSize: 10, color: "#94A3B8", marginTop: 24 }}>
          © 2026 Investisport
        </div>
      </div>
    </div>
  );
}

// ===== PAGINA IN COSTRUZIONE (investisport.it / www) =====
function PaginaCostruzione() {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#1B2846",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        background: "#fff", borderRadius: 16, padding: "48px 40px",
        width: 400, boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
        textAlign: "center",
      }}>
        <div style={{
          fontSize: 32, fontWeight: 700, color: "#1B2846",
          marginBottom: 4, letterSpacing: "-0.02em",
        }}>
          Investisport
        </div>
        <div style={{
          fontSize: 14, color: "#3B82F6", fontWeight: 600,
          marginBottom: 28,
        }}>
          Analisi e gestione sistemi di betting
        </div>
        <div style={{
          background: "#F8FAFC", borderRadius: 10, padding: "24px 16px",
          marginBottom: 28, border: "1px solid #E2E8F0",
        }}>
          <div style={{ fontSize: 28, marginBottom: 10 }}>
            🚧
          </div>
          <div style={{
            fontSize: 15, fontWeight: 600, color: "#1E293B",
            marginBottom: 8,
          }}>
            Sito in costruzione
          </div>
          <div style={{
            fontSize: 13, color: "#64748B", lineHeight: 1.6,
          }}>
            Stiamo lavorando alla piattaforma.<br />
            Il lancio ufficiale è previsto a breve.
          </div>
        </div>
        <a
          href="https://app.investisport.it"
          style={{
            display: "block", width: "100%", padding: "12px 0",
            fontSize: 14, fontWeight: 600, color: "#fff",
            background: "#3B82F6", border: "none", borderRadius: 8,
            cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
            textDecoration: "none", boxSizing: "border-box",
            transition: "background 0.2s",
          }}
          onMouseEnter={(e) => e.target.style.background = "#2563EB"}
          onMouseLeave={(e) => e.target.style.background = "#3B82F6"}
        >
          Accedi alla piattaforma
        </a>
        <div style={{
          fontSize: 10, color: "#94A3B8", marginTop: 24,
        }}>
          © 2026 Investisport
        </div>
      </div>
    </div>
  );
}

// Controlla se siamo sul dominio principale (non app.)
function isDominioprincipale() {
  const host = window.location.hostname;
  return host === "investisport.it" ||
         host === "www.investisport.it" ||
         host === "investisport.com" ||
         host === "www.investisport.com";
}

export default function App() {
  const [paginaAttiva, setPaginaAttiva] = useState(
    () => sessionStorage.getItem("investisport_pagina") || "dashboard"
  );
  const [sidebarAperta, setSidebarAperta] = useState(false);
  const [sbloccato, setSbloccato] = useState(false);
  const [sessioneCaricata, setSessioneCaricata] = useState(false);
  const [mailApertaId, setMailApertaId] = useState(null);
  const [drawerGuidaAperto, setDrawerGuidaAperto] = useState(false);
  const [ruoloUtente, setRuoloUtente] = useState(AUTH_DEFAULT);

  // Verifica sessione Supabase al caricamento + carica ruolo da app_users
  useEffect(() => {
    let annullato = false;

    const caricaRuolo = async (session) => {
      if (!session?.user?.email) {
        if (!annullato) setRuoloUtente(AUTH_DEFAULT);
        return;
      }
      try {
        const ruolo = await getUserRole(session.user.email);
        if (!annullato) {
          setRuoloUtente(ruolo);
          console.log(
            `[AUTH] Ruolo utente: ${ruolo.isAdmin ? "admin" : "non admin"}` +
            (ruolo.nome ? ` (${ruolo.nome})` : "") +
            (ruolo.trovato ? "" : " — utente non presente in app_users")
          );
        }
      } catch (e) {
        console.warn("[AUTH] Errore caricaRuolo:", e?.message || e);
        if (!annullato) setRuoloUtente(AUTH_DEFAULT);
      }
    };

    supabase.auth.getSession().then(({ data: { session } }) => {
      if (annullato) return;
      setSbloccato(!!session);
      setSessioneCaricata(true);
      if (session) caricaRuolo(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (annullato) return;
      setSbloccato(!!session);
      if (session) {
        caricaRuolo(session);
      } else {
        setRuoloUtente(AUTH_DEFAULT);
      }
    });

    return () => {
      annullato = true;
      subscription.unsubscribe();
    };
  }, []);

  const navigaA = (id, params) => {
    setPaginaAttiva(id);
    sessionStorage.setItem("investisport_pagina", id);
    if (id === "mail-sistema" && params?.mailId) {
      setMailApertaId(params.mailId);
    } else {
      setMailApertaId(null);
    }
  };

  const PageComponent = MENU_ITEMS.find(m => m.id === paginaAttiva)?.comp || Dashboard;

  // Dominio principale → pagina in costruzione
  if (isDominioprincipale()) {
    return <PaginaCostruzione />;
  }

  // Attendi verifica sessione prima di mostrare qualcosa
  if (!sessioneCaricata) {
    return (
      <div style={{
        minHeight: "100vh", display: "flex", alignItems: "center",
        justifyContent: "center", background: "#1B2846",
        fontFamily: "'DM Sans', sans-serif", color: "#94A3B8", fontSize: 14,
      }}>
        Caricamento...
      </div>
    );
  }

  // app.investisport.it / vercel → login + web app
  if (!sbloccato) {
    return <BetaLogin onLogin={() => setSbloccato(true)} />;
  }

  return (
    <AuthContext.Provider value={ruoloUtente}>
    <div style={{ fontFamily: "'DM Sans', sans-serif" }}>
      {/* ===== TASTO GUIDA FISSO ===== */}
      <button
        onClick={() => setDrawerGuidaAperto(true)}
        title="Apri guida"
        style={{
          position: "fixed", top: 12, right: 16, zIndex: 1000,
          background: "#1B2846", border: "none", borderRadius: 8,
          color: "#94A3B8", fontSize: 13, fontWeight: 600,
          padding: "7px 14px", cursor: "pointer",
          fontFamily: "'DM Sans', sans-serif",
          display: "flex", alignItems: "center", gap: 6,
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          transition: "color 0.15s, background 0.15s",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; e.currentTarget.style.background = "#243460"; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = "#94A3B8"; e.currentTarget.style.background = "#1B2846"; }}
      >
        <span>📖</span>
        <span>Guida</span>
      </button>

      {/* ===== DRAWER GUIDA ===== */}
      <GuidaDrawer
        aperto={drawerGuidaAperto}
        onChiudi={() => setDrawerGuidaAperto(false)}
        paginaAttiva={paginaAttiva}
      />
      {/* ===== SIDEBAR ===== */}
      <aside className={`sidebar ${sidebarAperta ? "open" : "closed"}`}>
        {/* Header */}
        <div className="sidebar-header">
          <button
            className="sidebar-hamburger"
            onClick={() => setSidebarAperta(!sidebarAperta)}
            title={sidebarAperta ? "Chiudi menu" : "Apri menu"}
          >
            {sidebarAperta ? "✕" : "☰"}
          </button>
          <span className="sidebar-logo">Investisport</span>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {MENU_ITEMS.map(item => (
            <button
              key={item.id}
              className={`sidebar-item ${paginaAttiva === item.id ? "active" : ""}`}
              onClick={() => navigaA(item.id)}
            >
              <span className="sidebar-item-icon">{item.icon}</span>
              <span className="sidebar-item-label">{item.label}</span>
              <span className="sidebar-tooltip">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <button
            className="sidebar-item"
            onClick={async () => {
              await supabase.auth.signOut();
              sessionStorage.removeItem("investisport_pagina");
              setPaginaAttiva("dashboard");
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(239,68,68,0.12)";
              e.currentTarget.style.color = "#FCA5A5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "none";
              e.currentTarget.style.color = "#94A3B8";
            }}
            title="Esci dalla piattaforma"
          >
            <span className="sidebar-item-icon">🔴</span>
            <span className="sidebar-item-label">Esci</span>
            <span className="sidebar-tooltip">Esci</span>
          </button>
          <div className="sidebar-footer-version">Investisport v1.0</div>
        </div>
      </aside>

      {/* ===== CONTENUTO PRINCIPALE ===== */}
      <main className={`main-content ${sidebarAperta ? "sidebar-open" : "sidebar-closed"}`}>
        <PageComponent onNavigate={navigaA} mailApertaId={paginaAttiva === "mail-sistema" ? mailApertaId : undefined} />
      </main>
    </div>
    </AuthContext.Provider>
  );
}
